export default __webpack_public_path__ + "static/media/ae.19ecf437.svg";